import { useState, type FormEvent } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "电影", to: "/category/movie" },
  { label: "电视剧", to: "/category/tv" },
  { label: "短视频", to: "/category/short" },
];

export default function SiteNavbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");

  const isActive = (to: string) => {
    if (to === "/") return location.pathname === "/";
    return location.pathname.startsWith(to);
  };

  const submitSearch = (e: FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    setMenuOpen(false);
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : "/search");
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-800/80 bg-background-900/95 backdrop-blur">
      <div className="mx-auto flex h-16 w-full items-center gap-4 px-4 md:h-20 md:px-6">
        <Link to="/" className="flex shrink-0 items-center gap-2.5 cursor-pointer">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-background-950 md:h-10 md:w-10">
            <i className="ri-play-circle-fill text-xl md:text-2xl" />
          </span>
          <span className="font-heading text-xl font-extrabold tracking-tight text-foreground-50 md:text-2xl">
            多多<span className="text-accent-500">视频</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`whitespace-nowrap rounded-md px-4 py-2 text-sm font-medium transition-colors cursor-pointer ${
                isActive(item.to)
                  ? "bg-primary-500/15 text-primary-300"
                  : "text-foreground-200 hover:bg-background-800 hover:text-foreground-50"
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <form onSubmit={submitSearch} className="ml-auto hidden items-center md:flex">
          <div className="relative">
            <i className="ri-search-line pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-base text-secondary-400" />
            <input
              type="text"
              name="q"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索电影、电视剧、短视频"
              className="h-10 w-56 rounded-md border border-background-700 bg-background-950/60 pl-9 pr-3 text-sm text-foreground-100 placeholder:text-secondary-500 focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500 lg:w-72"
            />
          </div>
          <button
            type="submit"
            className="ml-2 h-10 whitespace-nowrap rounded-md bg-primary-500 px-4 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
          >
            搜索
          </button>
        </form>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setMenuOpen((v) => !v)}
          className="ml-auto flex h-10 w-10 items-center justify-center rounded-md text-foreground-100 transition-colors hover:bg-background-800 md:hidden cursor-pointer"
        >
          <i className={menuOpen ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"} />
        </button>
      </div>

      {menuOpen && (
        <div className="border-t border-background-800 bg-background-900 px-4 pb-5 pt-4 md:hidden">
          <form onSubmit={submitSearch} className="mb-4">
            <div className="relative">
              <i className="ri-search-line pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-base text-secondary-400" />
              <input
                type="text"
                name="q"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索电影、电视剧、短视频"
                className="h-11 w-full rounded-md border border-background-700 bg-background-950/60 pl-9 pr-3 text-sm text-foreground-100 placeholder:text-secondary-500 focus:border-primary-500 focus:outline-none"
              />
            </div>
          </form>
          <nav className="flex flex-col gap-1">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                onClick={() => setMenuOpen(false)}
                className={`whitespace-nowrap rounded-md px-4 py-3 text-sm font-medium transition-colors cursor-pointer ${
                  isActive(item.to)
                    ? "bg-primary-500/15 text-primary-300"
                    : "text-foreground-200 hover:bg-background-800"
                }`}
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/about"
              onClick={() => setMenuOpen(false)}
              className="whitespace-nowrap rounded-md px-4 py-3 text-sm font-medium text-foreground-200 transition-colors hover:bg-background-800 cursor-pointer"
            >
              关于我们
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}